<script>
import loader from '@/components/Loader.vue';

export default {
  components: {loader},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    detalhe: {
      type: Object,
      default: () => ({}),
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    fechar() {
      this.$emit('fecha-modal');
    },
    formatarData(valor) {
      if (!valor) return '-';
      return new Date(valor).toLocaleDateString('pt-BR', {timeZone: 'UTC'});
    },
    formatarHora(valor) {
      if (!valor) return '-';
      return String(valor).slice(0, 5);
    },
    diaSemana(valor) {
      if (!valor) return '';
      let dia = new Date(valor).toLocaleDateString('pt-BR', {weekday: 'long', timeZone: 'UTC'});
      dia = dia.replace('-feira', '');
      return dia.charAt(0).toUpperCase() + dia.slice(1);
    },
  },
  computed: {
    dataExecucao() {
      return this.formatarData(this.detalhe.dataEvento);
    },
    horaInicio() {
      return this.formatarHora(this.detalhe.horaInicio);
    },
    horaFim() {
      return this.formatarHora(this.detalhe.horaFim);
    },
    totalHoras() {
      return this.detalhe.totalLabel || this.formatarHora(this.detalhe.decorrido);
    },
    totalClasse() {
      let minutos = this.detalhe.totalMinutos;
      if (minutos === undefined || minutos === null) {
        const label = this.detalhe.totalLabel || '';
        if (label.includes('-')) minutos = -1;
        else if (label.includes('+')) minutos = 1;
        else minutos = 0;
      }
      if (minutos > 0) return 'mdr-valor--positivo';
      if (minutos < 0) return 'mdr-valor--negativo';
      return '';
    },
    tipo() {
      return this.detalhe.tipo || '-';
    },
    gestor() {
      return this.detalhe.gestorSolicitante || '-';
    },
    observacaoData() {
      const dia = this.diaSemana(this.detalhe.dataEvento);
      const data = this.formatarData(this.detalhe.dataEvento);
      return `Registrado ${dia} - ${data}`;
    },
    temObservacao() {
      return !!this.detalhe.descricao;
    },
  },
};
</script>

<template>
  <v-dialog :value="show" max-width="1100" @click:outside="fechar" @input="val => !val && fechar()">
    <v-card class="modal-detalhe-registro">
      <!-- Cabeçalho -->
      <div class="mdr-header">
        <span class="mdr-titulo">Detalhes do Registro</span>
        <v-icon class="mdr-fechar" @click="fechar">fas fa-xmark</v-icon>
      </div>

      <div class="mdr-body">
        <!-- Linha de campos -->
        <div class="mdr-campos">
          <div class="mdr-campo">
            <span class="mdr-label">Data da Execução</span>
            <span class="mdr-valor">{{ dataExecucao }}</span>
          </div>
          <div class="mdr-campo">
            <span class="mdr-label">Hora Início</span>
            <span class="mdr-valor">{{ horaInicio }}</span>
          </div>
          <div class="mdr-campo">
            <span class="mdr-label">Hora Fim</span>
            <span class="mdr-valor">{{ horaFim }}</span>
          </div>
          <div class="mdr-campo">
            <span class="mdr-label">Total de Horas</span>
            <span class="mdr-valor" :class="totalClasse">{{ totalHoras }}</span>
          </div>
          <div class="mdr-campo">
            <span class="mdr-label">Tipo</span>
            <span class="mdr-valor">{{ tipo }}</span>
          </div>
          <div class="mdr-campo">
            <span class="mdr-label">Gestor</span>
            <span class="mdr-valor">{{ gestor }}</span>
          </div>
        </div>

        <!-- Observação / Justificativa -->
        <div v-if="temObservacao" class="mdr-observacao">
          <div class="mdr-obs-header">
            <span class="mdr-obs-autor">{{ gestor }}</span>
            <v-icon class="mdr-obs-bullet">fas fa-circle</v-icon>
            <span class="mdr-obs-data">{{ observacaoData }}</span>
          </div>
          <p class="mdr-obs-texto">{{ detalhe.descricao }}</p>
        </div>
      </div>

      <!-- Rodapé -->
      <div class="mdr-footer">
        <v-btn class="mdr-btn-fechar" outlined @click="fechar">Fechar</v-btn>
      </div>

      <loader :loader-primario="loader"/>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.modal-detalhe-registro {
  border-radius: 20px !important;
  overflow: hidden;
}

/* Cabeçalho */
.mdr-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #008693;
  padding: 12px 32px;
}

.mdr-titulo {
  font-family: Montserrat, sans-serif;
  font-weight: 900;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
}

.mdr-fechar {
  position: absolute;
  right: 24px;
  color: #ffffff !important;
  cursor: pointer;
}

/* Corpo */
.mdr-body {
  padding: 24px 32px;
}

/* Linha de campos */
.mdr-campos {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.mdr-campo {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 12px;
  border-left: 6px solid #7db9c1;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  flex: 1 1 140px;
  min-width: 120px;
}

.mdr-label {
  font-family: Lato, sans-serif;
  font-weight: 800;
  font-size: 14px;
  color: #2b2d2e;
}

.mdr-valor {
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #3d3d3d;
}

.mdr-valor--positivo {
  color: #2e9e52;
  font-weight: 700;
}

.mdr-valor--negativo {
  color: #db1427;
  font-weight: 700;
}

/* Observação */
.mdr-observacao {
  margin-top: 32px;
  border-left: 6px solid #7db9c1;
  border-radius: 6px;
  padding: 10px 24px;
}

.mdr-obs-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mdr-obs-autor {
  font-family: Montserrat, sans-serif;
  font-weight: 800;
  font-size: 14px;
  color: #278b97;
}

.mdr-obs-bullet {
  font-size: 5px !important;
  color: #278b97 !important;
}

.mdr-obs-data {
  font-family: Lato, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #7f7a78;
  text-decoration: underline;
  text-decoration-color: #278b97;
  text-decoration-thickness: 2px;
  text-underline-offset: 5px;
}

.mdr-obs-texto {
  margin: 16px 0 0;
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #161616;
}

/* Rodapé */
.mdr-footer {
  display: flex;
  justify-content: center;
  margin: 0 32px;
  padding: 24px 0 16px;
  border-top: 1px solid #278b97;
}

.mdr-btn-fechar {
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  font-size: 14px;
  text-transform: none;
  letter-spacing: normal;
  color: #2d2d2d !important;
  border: 1px solid #2d2d2d;
  border-radius: 10px;
  background-color: #ffffff !important;
  box-shadow: none !important;
}

/* ---- Telas pequenas ---- */
@media (max-width: 600px) {
  .mdr-header {
    padding: 12px 20px;
  }

  .mdr-fechar {
    right: 16px;
  }

  .mdr-body {
    padding: 16px 20px;
  }

  /* Campos em 2 por linha para caber sem apertar */
  .mdr-campo {
    flex: 1 1 40%;
  }

  .mdr-observacao {
    margin-top: 20px;
    padding: 10px 16px;
  }

  .mdr-footer {
    margin: 0 20px;
    padding: 16px 0 12px;
  }
}
</style>
